import { connect } from 'react-redux';
import { twitterActions } from 'components/settings/actions/twitter';
import { hasFeature } from 'components/shared/featureFlag';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { selectQueueState } from '../../../../../app/utils/reselect';
import { whatsappActions } from '../../../actions/whatsapp';
import MessagingList from '../../../components/sections/messaging/MessagingList';
import { messagingDeleteApp, messagingDeleteInstagramAccount, messagingDeletePage, messagingGetApps, messagingUpdateAccessToken, messagingUpdateInstagramPage, messagingUpdatePage, } from '../../../reducers/sections/messaging';
const mapStateToProps = (state) => {
    return {
        asyncStatus: state.settings.messaging.meta.asyncStatus,
        apps: state.settings.messaging.appList,
        queues: selectQueueState(state).queues,
        whatsappAsyncStatus: state.settings.whatsapp.meta.asyncStatus,
        whatsappIntegrations: state.settings.whatsapp.integrations,
        twitter: state.settings.twitter,
        hasTwitter: hasFeature(state, 'twitter-channel'),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        messagingGetApps: bindActionToPromise(dispatch, messagingGetApps),
        messagingDeleteApp: bindActionToPromise(dispatch, messagingDeleteApp),
        messagingDeletePage: bindActionToPromise(dispatch, messagingDeletePage),
        messagingDeleteInstagramAccount: bindActionToPromise(dispatch, messagingDeleteInstagramAccount),
        messagingUpdatePage: bindActionToPromise(dispatch, messagingUpdatePage),
        messagingUpdateInstagramPage: bindActionToPromise(dispatch, messagingUpdateInstagramPage),
        whatsappGetApps: bindActionToPromise(dispatch, whatsappActions.whatsappGetApps),
        whatsappUpdateIntegration: bindActionToPromise(dispatch, whatsappActions.whatsappUpdateIntegration),
        whatsappDeleteIntegration: bindActionToPromise(dispatch, whatsappActions.whatsappDeleteIntegration),
        updateAccessToken: bindActionToPromise(dispatch, messagingUpdateAccessToken),
        twitterGetAccounts: () => dispatch(twitterActions.readAccounts()),
        twitterGetOrganizationSettings: () => dispatch(twitterActions.getOrganizationSettings()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(MessagingList);
